export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      services: 'Services',
      portfolio: 'Portfolio',
      contact: 'Contact'
    },
    
    // Header
    header: {
      companyName: 'M.A.S Elite',
      tagline: 'Accounting & Tax Solutions',
      consultation: 'Free Consultation'
    },
    
    // Hero Section
    hero: {
      trustedBy: 'Trusted by 500+ Businesses',
      elevateYour: 'Elevate Your',
      financialSuccess: 'Financial Success',
      subtitle: 'Professional accounting and tax solutions that drive growth, ensure compliance, and maximize your financial potential.',
      features: {
        accurateTax: 'Accurate Tax Filing',
        financialGrowth: 'Financial Growth',
        compliance: 'Compliance Guaranteed'
      },
      cta: {
        getStarted: 'Get Started Today',
        viewServices: 'View Services'
      },
      stats: {
        satisfaction: 'Client Satisfaction',
        businesses: 'Businesses Served',
        support: 'Support Available'
      }
    },
    
    // Services Section
    services: {
      title: 'Professional Services',
      subtitle: 'Comprehensive financial solutions tailored to your unique needs',
      viewAll: 'View All Services',
      learnMore: 'Learn More'
    },
    
    // Portfolio Section
    portfolio: {
      title: 'Success Stories',
      subtitle: "See how we've helped businesses achieve financial excellence",
      filters: {
        all: 'All Projects',
        tax: 'Tax Solutions',
        consulting: 'Consulting',
        audit: 'Audit & Compliance',
        bookkeeping: 'Bookkeeping'
      },
      viewAll: 'View All Case Studies',
      caseStudy: 'View Case Study',
      clickToLearn: 'Click to learn more',
      stats: {
        savings: 'Savings',
        timeline: 'Timeline',
        team: 'Team'
      }
    },
    
    // Contact Section
    // In translations.js, contact section should have:
contact: {
  title: 'Get In Touch',
  subtitle: 'Ready to elevate your financial strategy? Contact us for a free consultation.',
  contactInfo: {
    email: 'Email Us',
    call: 'Call Us',
    visit: 'Visit Us'
  },
  whyChooseUs: {
    title: 'Why Choose Us?',
    points: [
      'Free Initial Consultation',
      '24/7 Emergency Support',
      'Certified Professionals',
      'Confidential & Secure'
    ]
  },
  form: {
    name: 'Full Name *',
    email: 'Email Address *',
    phone: 'Phone Number',
    service: 'Service Needed *',
    message: 'Message *',
    placeholder: {
      name: 'Mohamed Sayed Abosriea ',
      email: 'mohamedabosriea@masellite.com',
      phone: '+201270328820',
      message: 'Tell us about your financial needs...'
    },
    submit: 'Send Message',
    sending: 'Sending...',
    success: 'Message Sent Successfully!',
    successMessage: 'Thank you for contacting M.A.S Elite. We\'ll get back to you within 24 hours.',
    sendAnother: 'Send Another Message',
    note: 'We\'ll respond within 24 hours. All information is kept confidential.'
  }
},
    
    // Footer
    footer: {
      description: 'Professional accounting and tax solutions for businesses and individuals.',
      quickLinks: 'Quick Links',
      services: 'Services',
      contactUs: 'Contact Us',
      serviceList: [
        'Tax Planning',
        'Financial Auditing',
        'Bookkeeping',
        'Business Consulting',
        'Payroll Services'
      ],
      copyright: 'M.A.S Elite Accounting & Tax Office. All rights reserved.'
    },

    // Chatbot Translations - Added
    chatbot: {
      title: "M.A.S AI Tax Assistant",
      subtitle: "I'm M.A.S Smart Assistant. I can calculate your annual income tax. Please enter your annual net income in Egyptian Pounds (numbers only).",
      placeholder: "Enter amount here...",
      error: {
        arabicOnly: "Sorry, I only support Arabic. For more details, contact Consultant Mohamed Abu Sari: mohamedabosarie@gmail.com",
        taxOnly: "Sorry, my specialty is tax calculation only. You can contact Consultant Mohamed Abu Sari for other consultations: mohamedabosarie@gmail.com",
        enterAmount: "Please enter the annual income value as numbers so we can calculate the tax for you."
      },
      result: "Based on the annual income (${amount} EGP), the estimated tax is: ${tax} EGP. Note: This calculation is illustrative according to 2024 brackets.",
      note: "EGP 2026 Tax Calculator",
      close: "Close chat",
      send: "Send"
    }
  },
  
  ar: {
    // Navigation - Arabic
    nav: {
      home: 'الرئيسية',
      services: 'الخدمات',
      portfolio: 'الأعمال',
      contact: 'اتصل بنا'
    },
    
    // Header - Arabic
    header: {
      companyName: 'إم إيه إس إيليت',
      tagline: 'حلول المحاسبة والضرائب',
      consultation: 'استشارة مجانية'
    },
    
    // Hero Section - Arabic
    hero: {
      trustedBy: 'يثق بنا أكثر من 500 شركة',
      elevateYour: 'ارتقِ بـ',
      financialSuccess: 'نجاحك المالي',
      subtitle: 'حلول محاسبية وضريبية محترفة تدفع النمو، تضمن الامتثال، وتعظيم إمكاناتك المالية.',
      features: {
        accurateTax: 'تقديم الضرائب بدقة',
        financialGrowth: 'النمو المالي',
        compliance: 'ضمان الامتثال'
      },
      cta: {
        getStarted: 'ابدأ اليوم',
        viewServices: 'عرض الخدمات'
      },
      stats: {
        satisfaction: 'رضا العملاء',
        businesses: 'الشركات المخدومة',
        support: 'دعم متاح 24/7'
      }
    },
    
    // Services Section - Arabic
    services: {
      title: 'الخدمات المهنية',
      subtitle: 'حلول مالية شاملة مصممة خصيصًا لاحتياجاتك الفريدة',
      viewAll: 'عرض جميع الخدمات',
      learnMore: 'تعرف أكثر'
    },
    
    // Portfolio Section - Arabic
    portfolio: {
      title: 'قصص النجاح',
      subtitle: 'شاهد كيف ساعدنا الشركات على تحقيق التميز المالي',
      filters: {
        all: 'جميع المشاريع',
        tax: 'حلول الضرائب',
        consulting: 'الاستشارات',
        audit: 'التدقيق والامتثال',
        bookkeeping: 'مسك الدفاتر'
      },
      viewAll: 'عرض جميع الدراسات',
      caseStudy: 'عرض دراسة الحالة',
      clickToLearn: 'انقر لمعرفة المزيد',
      stats: {
        savings: 'التوفير',
        timeline: 'المدة',
        team: 'الفريق'
      }
    },
    
    // Contact Section - Arabic
    contact: {
      title: 'اتصل بنا',
      subtitle: 'مستعد لرفع مستوى استراتيجيتك المالية؟ اتصل بنا للحصول على استشارة مجانية.',
      contactInfo: {
        email: 'راسلنا',
        call: 'اتصل بنا',
        visit: 'زورنا'
      },
      whyChooseUs: {
        title: 'لماذا تختارنا؟',
        points: [
          'استشارة أولية مجانية',
          'دعم طوارئ 24/7',
          'محترفون معتمدون',
          'سري وآمن'
        ]
      },
      form: {
        name: 'الاسم الكامل *',
        email: 'عنوان البريد الإلكتروني *',
        phone: 'رقم الهاتف',
        service: 'الخدمة المطلوبة *',
        message: 'الرسالة *',
        placeholder: {
          name: 'محمد ابوسريع',
          email: 'Mohamedabosriea@masellite.com',
          phone: '+201270328820',
          message: 'أخبرنا عن احتياجاتك المالية...'
        },
        submit: 'إرسال الرسالة',
        sending: 'جاري الإرسال...',
        success: 'تم إرسال الرسالة بنجاح!',
        successMessage: 'شكرًا لتواصلك مع إم إيه إس إيليت. سوف نرد عليك خلال 24 ساعة.',
        sendAnother: 'إرسال رسالة أخرى',
        note: 'سوف نرد خلال 24 ساعة. جميع المعلومات محفوظة بسرية.'
      }
    },
    
    // Footer - Arabic
    footer: {
      description: 'حلول محاسبية وضريبية محترفة للشركات والأفراد.',
      quickLinks: 'روابط سريعة',
      services: 'الخدمات',
      contactUs: 'اتصل بنا',
      serviceList: [
        'تخطيط الضرائب',
        'التدقيق المالي',
        'مسك الدفاتر',
        'الاستشارات التجارية',
        'خدمات الرواتب'
      ],
      copyright: 'مكتب إم إيه إس إيليت للمحاسبة والضرائب. جميع الحقوق محفوظة.'
    },

    // Chatbot Translations - Added
    chatbot: {
      title: "مساعد الضرائب الذكي M.A.S",
      subtitle: "أنا مساعد M.A.S الذكي. يمكنني حساب ضريبة الدخل السنوية لك. من فضلك أدخل صافي الدخل السنوي بالجنيه المصري (أرقام فقط).",
      placeholder: "أدخل المبلغ هنا...",
      error: {
        arabicOnly: "نعتذر، أنا أدعم اللغة العربية فقط. لمزيد من التفاصيل تواصل مع المستشار محمد أبو سريع: mohamedabosarie@gmail.com",
        taxOnly: "عذراً، تخصصي هو حساب الضرائب فقط. يمكنك التواصل مع المستشار محمد أبو سريع للاستشارات الأخرى: mohamedabosarie@gmail.com",
        enterAmount: "من فضلك أدخل قيمة الدخل السنوي كأرقام لنقوم بحساب الضريبة لك."
      },
      result: "بناءً على الدخل السنوي (${amount} ج.م)، فإن الضريبة السنوية المطلوبة هي: ${tax} ج.م. ملاحظة: هذا الحساب استرشادي وفقاً لشرائح 2024.",
      note: "حاسبة الضرائب المصرية لعام 2024",
      close: "إغلاق المحادثة",
      send: "إرسال"
    }
  }
};

// Tax calculation function - Add this export at the end
export const calculateEgyptTax = (income) => {
  if (income <= 40000) return 0;
  else if (income <= 45000) return (income - 30000) * 0.10;
  else if (income <= 60000) return 1500 + (income - 45000) * 0.15;
  else if (income <= 200000) return 3750 + (income - 60000) * 0.20;
  else if (income <= 400000) return 31000 + (income - 200000) * 0.225;
  else return 76000 + (income - 400000) * 0.275;
};

// Optional: Export chatbot translations separately for easy access
export const chatbotTranslations = {
  en: {
    title: "M.A.S AI Tax Assistant",
    subtitle: "I'm M.A.S Smart Assistant. I can calculate your annual income tax. Please enter your annual net income in Egyptian Pounds (numbers only).",
    placeholder: "Enter amount here...",
    error: {
      arabicOnly: "Sorry, I only support Arabic. For more details, contact Consultant Mohamed Abu Sari: mohamedabosarie@gmail.com",
      taxOnly: "Sorry, my specialty is tax calculation only. You can contact Consultant Mohamed Abu Sari for other consultations: mohamedabosarie@gmail.com",
      enterAmount: "Please enter the annual income value as numbers so we can calculate the tax for you."
    },
    result: "Based on the annual income (${amount} EGP), the estimated tax is: ${tax} EGP. Note: This calculation is illustrative according to 2024 brackets.",
    note: "EGP 2026 Tax Calculator",
    close: "Close chat",
    send: "Send"
  },
  ar: {
    title: "مساعد الضرائب الذكي M.A.S",
    subtitle: "أنا مساعد M.A.S الذكي. يمكنني حساب ضريبة الدخل السنوية لك. من فضلك أدخل صافي الدخل السنوي بالجنيه المصري (أرقام فقط).",
    placeholder: "أدخل المبلغ هنا...",
    error: {
      arabicOnly: "نعتذر، أنا أدعم اللغة العربية فقط. لمزيد من التفاصيل تواصل مع المستشار محمد أبو سريع: mohamedabosarie@gmail.com",
      taxOnly: "عذراً، تخصصي هو حساب الضرائب فقط. يمكنك التواصل مع المستشار محمد أبو سريع للاستشارات الأخرى: mohamedabosarie@gmail.com",
      enterAmount: "من فضلك أدخل قيمة الدخل السنوي كأرقام لنقوم بحساب الضريبة لك."
    },
    result: "بناءً على الدخل السنوي (${amount} ج.م)، فإن الضريبة التقريبية هي: ${tax} ج.م. ملاحظة: هذا الحساب استرشادي وفقاً لشرائح 2024.",
    note: "حاسبة الضرائب المصرية لعام 2024",
    close: "إغلاق المحادثة",
    send: "إرسال"
  }
};